<template>
  <CellGroup class="pdf_box_body">
    <Cell :title="pdf_list_data.key" />
    <Cell>
      <div class="pdf_box">
        <VanImage
          v-if=" $common.SeeJudge(pdf_list_data.value)==='img'"
          :src="pdf_list_data.value"
        />
        <div
          v-else
          class="demo"
          :class="active"
        />

      </div>
    </Cell>
  </CellGroup>

</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
import axios from 'axios'

// @ is an alias to /src
import { NavBar, Image as VanImage, Col, Row, Tag, Cell, CellGroup } from 'vant'

export default {

  name: 'Home',
  components: {
    NavBar,
    VanImage,
    Col,
    Row,
    Tag,
    Cell, CellGroup
  },
  props: {
    list_index: {},
    pdf_list_data: {
    },
    pdf_data_list_name: {}

  },
  data() {
    return {
      pdfh5: null

    }
  },
  created() {
    if (this.$common.SeeJudge(this.pdf_list_data.value) === 'pdf') {
      this.active = `dom${this.list_index}`
      this.H5Pdf()
    } else {
      this.$emit('LoopRenderingPDF')
    }
  },

  methods: {
    async H5Pdf() {
      const _this = this

      await axios.get(this.pdf_list_data.value, {
        responseType: 'arraybuffer'
      })
        .then(res => {
          this.pdfh5 = new Pdfh5(`.${this.active}`, {
            data: res.data,
            cMapUrl: 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/'
          })
          this.pdfh5.on('complete', function(status, msg, time) {
            _this.$emit('LoopRenderingPDF')
          })
        })
    }

  }
}
</script>
<style  lang="less" scoped>

    .pdf_h5_btn_box {
        padding-bottom: 40px;
    }

    .pdf_h5_btn_box{
        text-align: center;
        margin: 16px 0;
        width: 100%;
    }
    .pdf_h5_btn_text{
        font-size: 20px;
        margin: 16px 0 ;
    }
    .van-tab__pane{
        width: auto;
        margin: 20px;
        background-color: #fff;
        border-radius: 12px;
        flex-shrink: 0;
        box-sizing: border-box;
    }
    .convey_box{

        background:rgba(245,245,245,1);
    }
    .pdf_box_bg{
        height: 100%;
    }
    .van-doc-demo-block__card{
        margin: 0 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }
    .banner_box{
        position: relative;
        .banner_title_box{
            margin-left: 28px;
            margin-top: 40px;
            position: absolute;
            z-index: 10;
            color: #fff;
            .banner_title{
                font-size: 16px;
                margin-bottom: 16px;
            }
            .case_status{
                margin: 0;
                font-size: 22px;
            }
        }
    }

</style>
